export const INVOICE_PERIOD_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: '30', label: 'Last 30 days' },
  { value: '60', label: 'Last 60 days' },
  { value: '90', label: 'Last 90 days' },
] as const
